import { Trash04Icon } from '@langchain/untitled-ui-icons';
import { Button } from '@mui/joy';

export const AnnotationQueueBulkViewSelectedRunsFooter = ({
  shouldShowSelectAll,
  setDeleteModalOpen,
  totalQueueSize,
  setSelectAllRuns,
  numRunsSelected,
}: {
  shouldShowSelectAll: boolean;
  setDeleteModalOpen: (open: boolean) => void;
  totalQueueSize: number;
  setSelectAllRuns: (selectAllRuns: boolean) => void;
  numRunsSelected: number;
}) => {
  return (
    <div className="fixed bottom-9 left-1/2 z-20 flex -translate-x-1/2 items-center gap-6 rounded-md border border-secondary bg-background px-8 py-4 shadow-lg">
      <div className="flex items-center gap-4">
        <div className="flex flex-col">
          <div className="text-md font-medium">
            {numRunsSelected} {numRunsSelected === 1 ? 'run' : 'runs'} selected
          </div>
          {shouldShowSelectAll && (
            <div className="text-sm text-quaternary">
              Only visible runs are selected
            </div>
          )}
        </div>
        {shouldShowSelectAll && (
          <div className="flex flex-col">
            <Button
              size="sm"
              variant="plain"
              color="primary"
              onClick={() => setSelectAllRuns(true)}
            >
              Select all {totalQueueSize} runs
            </Button>
          </div>
        )}
      </div>
      <div className="h-6 w-[1px] bg-tertiary"></div>
      <Button
        color="danger"
        size="sm"
        variant="outlined"
        onClick={() => setDeleteModalOpen(true)}
      >
        <div className="flex items-center gap-1.5">
          <Trash04Icon className="h-4 w-4" />
          <div className="text-md">Delete</div>
        </div>
      </Button>
    </div>
  );
};
